import { defineComponent, computed } from 'vue'
import ApiDocsAnchors from '@/modules/api/components/ApiDocsAnchors/ApiDocsAnchors.vue'
import ApiDocsNav from '@/modules/api/components/ApiDocsNav/ApiDocsNav.vue'
import { useMainStore } from '@/store/main/main'

export default defineComponent({
  name: 'ApiDocsMain',
  components: {
    ApiDocsAnchors,
    ApiDocsNav,
  },
  setup() {
    const mainStore = useMainStore()
    const isMobile = computed(() => mainStore.isMobile)

    return { isMobile }
  },
})
